import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetToDo = () => {
    const {
        data: toDo,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["toDo"],
        queryFn: () =>
            axiosManager.get$("/student/todo").then((res) => res.data),
    });

    return { toDo, error, isLoading };
};

export default useGetToDo;
